import { FlexBox, IconButton } from '@dixa/lib-shared-habla';
import { PropsWithChildren } from 'lib-shared-types-utils';

import styles from './contactAttributeFormField.module.scss';

type ContactAttributeFormFieldProps = {
  onClick: () => void;
} & PropsWithChildren;

export function ContactAttributeFormField({
  children,
  onClick,
}: ContactAttributeFormFieldProps): JSX.Element {
  return (
    <FlexBox gap="200" alignItems="center">
      <div className={styles.wrapper}>{children}</div>
      <IconButton variant="tertiary" icon="trash" onClick={onClick} />
    </FlexBox>
  );
}
